import * as React from "react";
import classnames from "classnames";

type Props = React.HTMLProps<HTMLButtonElement> & {
  children: React.ReactNode;
  type?: "submit";
  bg?: "default" | "grey" | "white" | "green" | "red";
  color?: "grey" | "black";
  margin?: "auto" | "my-8" | "top" | "m-4" | "mx-4" | "none" | "mx-2";
  padding?: "none" | "px-6" | "p-2" | "px-10" | "p-1.5" | "p-1";
  radius?: "md";
  transform?: "capitalize" | "uppercase";
  width?: "none";
};

let getRadius = (radius: Props["radius"]) => {
  switch (radius) {
    case "md":
      return "rounded-md";
    default:
      return "rounded-2xl";
  }
};

let getPadding = (padding: Props["padding"]) => {
  switch (padding) {
    case "p-1":
      return "p-1";
    case "p-1.5":
      return "p-1.5";
    case "p-2":
      return "p-2";
    case "px-10":
      return "py-4 px-10";
    case "px-6":
      return "py-2.5 px-6";
    case "none":
      return "p-none";
    default:
      return "py-2.5 px-4";
  }
};

let getMargin = (margin: Props["margin"]) => {
  switch (margin) {
    case "none":
      return "m-0";
    case "mx-2":
      return "mx-2";
    case "mx-4":
      return "mx-4";
    case "m-4":
      return "m-4";
    case "my-8":
      return "my-8";
    case "top":
      return "mt-8 mb-4";
    case "auto":
      return "m-auto";
    default:
      return "my-4";
  }
};

let getColor = (color: Props["color"]) => {
  switch (color) {
    case "black":
      return "text-black";
    case "grey":
      return "text-grey-1";
    default:
      return "text-white";
  }
};

let getBg = (bg: Props["bg"]) => {
  switch (bg) {
    case "green":
      return "bg-green-primary"; 
    case "red":
      return "bg-red-500";
    case "white":
      return "bg-white";
    case "grey":
      return "bg-white hover:bg-gray-opacity";
    default:
      return "bg-blue-primary";
  }
};

let getWidth = (width: Props["width"]) => {
  switch (width) {
    case "none":
      return "w-none";
    default:
      return "w-full";
  }
};

export const Button = ({
  children,
  type,
  bg,
  width,
  color,
  margin,
  padding,
  radius,
  ...props
}: Props) => {
  return (
    <button
      className={classnames(
        "focus:outline-none whitespace-nowrap tracking-wider font-semibold text-sm",
        getBg(bg),
        getColor(color),
        getMargin(margin),
        getPadding(padding),
        getRadius(radius),
        getWidth(width)
      )}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};
